import RoleService from './RoleService';

export default {
	'services.onboardingRoleService': {
		class: RoleService,
		deps: [{ $ref: 'services.APIService' }],
	},
};
